import React, { useMemo } from 'react';
import TableContainerReactTable from '../../../Components/Common/TableContainerReactTable';

interface Account {
  status: string;
  name: string;
  location: string;
  type: string;
  active: boolean;
  mainPhone: string;
  industryName: string;
  address: string;
  supplier: boolean;
  parentName: string;
}

// Mock account data - in real app this would come from API/Redux
const mockAccounts: Account[] = [
  {
    status: 'Active',
    name: 'ABC Corporation',
    location: 'Auckland',
    type: 'Customer',
    active: true,
    mainPhone: '+64 9 123 4567',
    industryName: 'Manufacturing',
    address: '123 Queen Street, Auckland',
    supplier: false,
    parentName: 'ABC Holdings Ltd'
  },
  {
    status: 'Inactive',
    name: 'XYZ Suppliers Ltd',
    location: 'Wellington',
    type: 'Supplier',
    active: false,
    mainPhone: '+64 4 987 6543',
    industryName: 'Wholesale',
    address: '456 Lambton Quay, Wellington',
    supplier: true,
    parentName: ''
  },
  {
    status: 'Active',
    name: 'Tech Solutions Inc',
    location: 'Christchurch',
    type: 'Customer',
    active: true,
    mainPhone: '+64 3 555 0123',
    industryName: 'Technology',
    address: '789 Colombo Street, Christchurch',
    supplier: false,
    parentName: 'Tech Group NZ'
  },
  {
    status: 'Active',
    name: 'Green Energy Co',
    location: 'Hamilton',
    type: 'Both',
    active: true,
    mainPhone: '+64 7 444 5678',
    industryName: 'Energy',
    address: '321 Victoria Street, Hamilton',
    supplier: true,
    parentName: ''
  },
  {
    status: 'Pending',
    name: 'Food Distributors Ltd',
    location: 'Tauranga',
    type: 'Supplier',
    active: true,
    mainPhone: '+64 7 333 9876',
    industryName: 'Food & Beverage',
    address: '654 Cameron Road, Tauranga',
    supplier: true,
    parentName: 'Food Holdings Group'
  },
  {
    status: 'Active',
    name: 'Retail Chain NZ',
    location: 'Dunedin',
    type: 'Customer',
    active: true,
    mainPhone: '+64 3 222 1111',
    industryName: 'Retail',
    address: '987 George Street, Dunedin',
    supplier: false,
    parentName: 'Retail International'
  },
  {
    status: 'Active',
    name: 'Construction Pro',
    location: 'Palmerston North',
    type: 'Customer',
    active: true,
    mainPhone: '+64 6 111 2222',
    industryName: 'Construction',
    address: '147 Main Street, Palmerston North',
    supplier: false,
    parentName: ''
  },
  {
    status: 'Inactive',
    name: 'Medical Supplies Co',
    location: 'Rotorua',
    type: 'Supplier',
    active: false,
    mainPhone: '+64 7 888 7777',
    industryName: 'Healthcare',
    address: '258 Fenton Street, Rotorua',
    supplier: true,
    parentName: 'Health Corp Ltd'
  }
];

const AccountGrid = () => {

  const columns = useMemo(
    () => [
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const status = cell.getValue();
          const isActive = status === 'Active';
          return (
            <div className="text-start ps-2">
              <i className={`ri-circle-fill fs-6 ${isActive ? 'text-success' : 'text-danger'}`}></i>
            </div>
          );
        },
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div className="text-left">
              {cell.getValue()}
            </div>
          );
        },
      },
      {
        header: "Location",
        accessorKey: "location",
        enableColumnFilter: false,
      },
      {
        header: "Type",
        accessorKey: "type",
        enableColumnFilter: false,
      },
      {
        header: "Active",
        accessorKey: "active",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const isActive = cell.getValue();
          return isActive ? (
            <div className="text-start ps-1">
              <i className="ri-checkbox-circle-line fs-17 align-middle"></i>
            </div>
          ) : null;
        },
      },
      {
        header: "Main Phone",
        accessorKey: "mainPhone",
        enableColumnFilter: false,
      },
      {
        header: "Industry Name",
        accessorKey: "industryName",
        enableColumnFilter: false,
      },
      {
        header: "Address",
        accessorKey: "address",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div className="text-left">
              {cell.getValue()}
            </div>
          );
        },
      },
      {
        header: "Supplier",
        accessorKey: "supplier",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const isSupplier = cell.getValue();
          return isSupplier ? (
            <div className="text-start ps-1">
              <i className="ri-checkbox-circle-line fs-17 align-middle"></i>
            </div>
          ) : null;
        },
      },
      {
        header: "Parent Name",
        accessorKey: "parentName",
        enableColumnFilter: false,
      },
    ],
    []
  );


  return (
    <React.Fragment>
      <TableContainerReactTable
        columns={columns}
        data={mockAccounts}
        isGlobalFilter={false}
        customPageSize={10}
        tableClass="table-centered align-middle table-nowrap table-sm mb-0"
        theadClass="table-light"
        divClass="table-responsive"
      />
    </React.Fragment>
  );
};

export default AccountGrid;
